export const Ellipse = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
   <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <circle opacity="0.4" cx="12" cy="12" r="12" fill="white" />
      <circle cx="12" cy="12" r="7.5" fill="white" />
   </svg>
)
